<template>
    <div class="pa-5">
        <div>
            <strong>{{ "Single package" | t }}:</strong>
        </div>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Neto weight" | t }} (g)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.neto_weight | rn(0) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Empty package weight" | t }} (g)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.package_weight | rn(0) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Bruto weight" | t }} (g)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.bruto_weight | rn(0) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Outer carton height" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.outer_carton_height | rn(1) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Outer carton depth" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.outer_carton_depth | rn(1) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Outer carton width" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.outer_carton_width | rn(1) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Package material" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.package_material ? activeProduct.package_material : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mb-3" />
        <div>
            <strong>{{ "Group package" | t }}:</strong>
        </div>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Box type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_box_type ? activeProduct.group_package_box_type : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Bags in the box" | t }} ({{ "pcs" | t }})</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.bags_in_box | rn }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Box height" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_outer_carton_height | rn(1) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Box depth" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_outer_carton_depth | rn(1) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Box width" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_outer_carton_width | rn(1) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Empty Box weight" | t }} (g)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_empty_box_weight | rn(0) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Group package bruto weight" | t }} (g)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_bruto_weight | rn(0) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Box code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.group_package_box_code ? activeProduct.group_package_box_code : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mb-3" />
        <div>
            <strong>{{ "Transparent wrap package" | t }}:</strong>
        </div>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Transparent wrap dimensions" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.transparent_wrap_dimensions ? activeProduct.transparent_wrap_dimensions : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Transparent wrap width" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.transparent_wrap_width | rn(2) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Transparent wrap length" | t }} (mm)</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.transparent_wrap_length | rn(2) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Transparent wrap comments" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.transparent_wrap_comment ? activeProduct.transparent_wrap_comment : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Transparent wrap code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.transparent_wrap_code ? activeProduct.transparent_wrap_code : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mb-0" />
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "package-tab",
    mounted() {},
    computed: {
        ...mapState("ProductStore", ["activeProduct"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
